import Link from '@tiptap/extension-link';
import StarterKit from '@tiptap/starter-kit';
import Highlight from '@tiptap/extension-highlight';
import { UrlRegex } from '../../constants';
import { InlineInfoCard } from './inlineInfoCardExtension';
import { markdownLinkPasteRule } from './markdownLinkPasteRule';
import { skipAlreadyLinkedText } from './skipAlreadyLinkedText';
import { SnippetExtension } from './snippetExtension';
import { TextCaseExtension } from './textCaseExtension';

export const RICH_TEXT_EDITOR_EXTENSIONS = [
  StarterKit.configure({
    heading: false,
    blockquote: false,
    codeBlock: false,
    horizontalRule: false,
    code: false,
  }),
  Link.extend({
    inclusive: false,
    addPasteRules() {
      return [
        markdownLinkPasteRule(this.type),
        ...(this.parent?.() ?? []).map((rule) =>
          skipAlreadyLinkedText(rule, this.type),
        ),
      ];
    },
  }).configure({
    openOnClick: false,
    autolink: true,
    validate: (href) => UrlRegex.test(href),
  }),
  InlineInfoCard,
  SnippetExtension,
  TextCaseExtension,
  Highlight.extend({
    name: 'decoration',
    addAttributes() {
      return {
        color: {
          default: null,
          renderHTML: ({ color }) =>
            color
              ? {
                  'data-color': color,
                  style: `background-color: ${color}`,
                }
              : {},
        },
      };
    },
  }),
];
